import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { normalizeRole } from '../../shared/utils/role.utils';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedHomeRedirectGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  canActivate(): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }

    if (!this.authService.isAuthenticated()) {
      return true;
    }

    const user = this.authService.getCurrentUser();
    const role = normalizeRole(user?.role);

    const dashboardPath = this.getDashboardPath(role);
    this.router.navigate([dashboardPath]);
    return false;
  }

  private getDashboardPath(role: string): string {
    switch (role) {
      case 'TENANT':
        return '/dashboard/tenant';
      case 'VENDOR':
        return '/dashboard/vendor';
      case 'SUPER_ADMIN':
      case 'ADMIN':
      case 'SUPPORT':
        return '/dashboard/super-admin';
      case 'LANDLORD':
      case 'PROPERTY_MANAGER':
      case 'PROPERTY_OWNER':
      default:
        return '/dashboard/landlord';
    }
  }
}
